import { useEffect, useState } from 'react';
import { initTagger } from '../initTagger';

export const useLovable = () => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    try {
      initTagger();
      setInitialized(true);
    } catch (error) {
      console.error('Failed to initialize Lovable:', error);
      setInitialized(false);
    }
  }, []);

  return {
    initialized,
  };
};

export default useLovable;
